class PromoBanner extends HTMLElement {
  constructor() {
    super();

    this.slides = Array.from(this.querySelectorAll('[data-promo-slide]'));
    this.currentIndex = 0;
    this.intervalId = null;
    this.rotateDelay = 4000;
    this.hasMultipleSlides = this.slides.length > 1;

    if (!this.hasMultipleSlides) {
      this.querySelectorAll('[data-promo-prev], [data-promo-next]').forEach((button) => {
        button.hidden = true;
      });
      return;
    }

    this.prevButton = this.querySelector('[data-promo-prev]');
    this.nextButton = this.querySelector('[data-promo-next]');

    this.prevButton.addEventListener('click', () => this.goTo(this.currentIndex - 1, 'prev'));
    this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1, 'next'));

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.play());

    this.play();
  }

  goTo(index, direction = 'next') {
    const total = this.slides.length;
    const nextIndex = ((index % total) + total) % total;

    if (nextIndex === this.currentIndex) return;

    const current = this.slides[this.currentIndex];
    const next = this.slides[nextIndex];

    current.classList.remove('is-active', 'slide-in-next', 'slide-in-prev');
    current.setAttribute('aria-hidden', 'true');

    this.currentIndex = nextIndex;

    next.classList.add('is-active', direction === 'prev' ? 'slide-in-prev' : 'slide-in-next');
    next.removeAttribute('aria-hidden');

    setTimeout(() => {
      next.classList.remove('slide-in-next', 'slide-in-prev');
    }, 320);

    this.restart();
  }

  play() {
    this.pause();
    this.intervalId = setInterval(() => {
      this.goTo(this.currentIndex + 1, 'next');
    }, this.rotateDelay);
  }

  pause() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  restart() {
    this.pause();
    this.play();
  }

  disconnectedCallback() {
    this.pause();
  }
}

if (!customElements.get('promo-banner')) {
  customElements.define('promo-banner', PromoBanner);
}
